export default theme => ({
  container: {
    margin: 0
  },
  usersTitle: {
    color: theme.palette.primary.main,
    marginBottom: '1em'
  }
});